module.exports = __webpack_public_path__ + "img/x1-five.9cdcef40.png";